import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router';
import HlsToolBar from 'components/HlsToolbar';
import axios from 'axios';
import LayoutPanel from 'components/LayoutPanel';
import ManualComponent from './manualHls';
import AutoComponent from './autoHls';
const HlsComponent = () => {
  return (
    <>
      {sessionStorage.getItem('broadcastType') == 'auto' ? (
        <AutoComponent />
      ) : (
        <ManualComponent />
      )}
    </>
  );
};
export default HlsComponent;
